export enum CerberusErrorCodesEnum {
    Unknown = 0,
    Validation = 1,
    InsufficientPermissions = 2,
    PatchActionIsNotAllowed = 3,
    ProductUsageIsNotPermitted = 4,
    Kicked = 6,

    NotUniqueUserName = 25,
    NotUniqueEmail = 26,
    UserNotFound = 27,
    RegistrationCodeOrSerialNumberCannotBeEmpty = 28,
    ShortUserName = 29,
    UserCurrentPasswordIsIncorrect = 30,
    PasswordFormatIsIncorrect = 31,
    CouldNotChangePassword = 32,
    UserNameOrPasswordIsIncorrect = 33,
    UserEmailIsNotConfirmed = 34,
    HasNotReceivedUserEmail = 35,
    UserCanNotHaveMoreThanOneSite = 36,
    UserCanNotDeleteHimself = 37,
    UserIsNotInSite = 38,
    UserIsExpired = 39,
    CanNotHaveMoreThanOneExternalAccount = 40,
    ThisExternalAccountExist = 41,
    UserCanNotHasMoreThanOneSite = 42,
    UserAlreadyExists = 43,

    IdentityOperationException = 50,
    TokenIsInvalidOrExpired = 51,
    ExternalAuthenticationError = 52,
    IdPIsNotPresentInParams = 53,
    DiscoveryDocumentCannotBeFound = 54,
    InvalidAuthorizationCode = 55,

    InvalidLicenseSerialNumber = 75,
    InvalidRegistrationCode = 76,
    LicenseUserSlotsAreUsed = 77,
    RegistrationCodeUserSlotsAreUsed = 78,
    InvalidRegistrationCodeOrLicenseSerialNumber = 79,
    LicenseNotFound = 80,
    LicenseUsersCountCantBeLessThanZero = 81,
    LicenseMaxUsersCountCannotBeReduced = 82,
    LicenseDurationCannotBeReduced = 83,
    LicenseStartDateCannotBeMovedInPast = 84,
    LicenseDoesNotBelongToASite = 85,
    LicenseDoesNotBelongToADealer = 86,
    LicenseIsNotAvailable = 87,
    LicenceIsAlreadyInUse = 88,
    DemoLicenseCanNotBeEditted = 89,

    EULANotFound = 100,

    ProductNotFound = 125,

    SiteNotFound = 150,
    ImpossibleChangeOfSitesStructure = 151,
    SiteUsersCountCantBeLessThanZero = 152,
    SubSiteUsersCantBeMoreThanAvailableInParentSite = 153,
    SiteUsageIsNotPermitted = 154,
    SiteIsNotInSubTreeStructure = 155,
    CanNotDeleteSiteWithUsers = 156,
    InstitutionCannotBeCreated = 157,
    InstitutionCannotBeChanged = 158,

    BundleNotFound = 175,
    DealerDoesNotHaveAccessToBundle = 176,
    NoValidProductsToAssignToBundle = 177,
    BundlePriceNotFound = 178,

    RegistrationCodeNotFound = 200,
    RegistrationCodeIsNotUnique = 201,

    MessageTemplateNotFound = 225,
    MessageTemplateDisabled = 226,
    SameTypeMessageTemplateExists = 227,
    CanNotOverrideHighLevelSettings = 228,

    DeviceLimitIsReached = 250,
    DeviceNotFound = 251,

    SessionNotFound = 275,

    FileNotFound = 300,
    FileNameIsNotUnique = 301,
    NotEnoughFreeSpaceToUploadFile = 302,

    ProductSettingNotFound = 325,

    FilterStartTimeCannotBeMoreThanEndTime = 10000
}
